<template>

	<page>
		<title-view>
			ניהול אזורים
			<v-btn slot="actions" btn @click="openModal = true">הוסף אזור</v-btn>
		</title-view>
		<row>
			<c-col>
				<areas-table @edit="onEdit"/>
			</c-col>
		</row>
		<popup-dialog v-model="openModal">
			<span slot="header">יצירת/עריכת אזור</span>
			<area-form @save="openModal = false"/>
		</popup-dialog>

	</page>


</template>

<script>
	import AreaForm from "src/view/areas/AreaForm";
	import AreasTable from "src/view/areas/AreasTable";
	import AreaModule from "src/store/modules/Area.module";

	export default {
		name: "areas-view",
		components: {AreasTable, AreaForm},
		data() {
			return {
				openModal: false
			};
		},
		methods: {
			onEdit(Area) {
				this.$store.commit(AreaModule.types.GET, Area);
				this.openModal = true;
			}
		}

	};
</script>

<style scoped>

</style>
